import {
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import Image from "../../assets/images/frame.png";

const CallSection: FC = () => {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container sx={{ py: { xs: 4, md: "16px" } }}>
      <Typography
        variant="h3"
        fontSize={{ xs: 20, md: 40 }}
        textAlign="center"
        paddingX={{ xs: 4, md: 14 }}
        marginTop={{ xs: 2, md: -2 }}
      >
        {t("explore_the_universe_of_cryptocurrency")}{" "}
        <span style={{ color: "#00DB97" }}>{t("enhance_your_results")}</span>
      </Typography>
      <img
        src={Image}
        alt="Ebinex: Explore o universo da negociação de criptomoedas e potencialize seus resultados."
        width="100%"
        style={{ position: "relative", top: -25 }}
      />
      <Stack
        direction="row"
        spacing={1}
        justifyContent="center"
        sx={{ position: "relative", top: { xs: -50, md: -120 } }}
      >
        <Button
          component={RouterLink}
          size={isMobile ? "medium" : "large"}
          to="/register"
          variant="contained"
        >
          {t("register")}
        </Button>
        <Button
          component={RouterLink}
          to="/register"
          variant="text"
          size={isMobile ? "medium" : "large"}
        >
          {t("open_your_demo_account")}
        </Button>
      </Stack>
    </Container>
  );
};

export default CallSection;
